import React from 'react'
import { BrandOptions, useBrand } from '../../providers/brandProvider'
import { IntercomLogo as IntercomLogoDefault } from './element'

export const IntercomLogo = (): React.ReactElement => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <IntercomLogoDefault />
  }
  return <IntercomLogoLegacy />
}
export const IntercomLogoLegacy = (): React.ReactElement => {
  return (
    <svg
      focusable="false"
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="intercom-logo"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.6053 0H4.51504C2.02161 0 0 2.01487 0 4.5v27C0 33.9851 2.02161 36 4.51504 36H31.6053c2.4934 0 4.515-2.0149 4.515-4.5v-27c0-2.48513-2.0216-4.5-4.515-4.5zm-8.7298 6.60037c0-.66262.5395-1.20037 1.2044-1.20037.6648 0 1.2044.53775 1.2044 1.20037V22.6327c0 .6627-.5396 1.2004-1.2044 1.2004-.6649 0-1.2044-.5377-1.2044-1.2004V6.60037zm-6.0197-.6075c0-.66262.5395-1.20037 1.2044-1.20037.6648 0 1.2044.53775 1.2044 1.20037V23.3932c0 .6627-.5396 1.2004-1.2044 1.2004-.6649 0-1.2044-.5377-1.2044-1.2004V5.99287zm-6.0197.6075c0-.66262.5395-1.20037 1.2044-1.20037.6648 0 1.2032.53775 1.2032 1.20037V22.6327c0 .6627-.5384 1.2004-1.2032 1.2004-.6649 0-1.2044-.5377-1.2044-1.2004V6.60037zM4.81643 9c0-.66263.53841-1.20038 1.20325-1.20038.66484 0 1.20439.53775 1.20439 1.20038v10.7932c0 .6627-.53955 1.2004-1.20439 1.2004-.66484 0-1.20325-.5377-1.20325-1.2004V9zM30.884 27.3037c-.1851.1598-4.646 3.8892-12.8238 3.8892-8.17791 0-12.63651-3.7294-12.82389-3.8892-.50455-.4308-.56438-1.188-.13093-1.692.43118-.5017 1.18971-.5613 1.69427-.1316.06998.0585 4.05335 3.3131 11.25935 3.3131 7.2963 0 11.2176-3.2782 11.256-3.3108.5035-.432 1.2654-.3735 1.6966.1293.4357.504.377 1.2612-.1276 1.692zm.4199-7.5105c0 .6627-.5395 1.2004-1.2044 1.2004-.6648 0-1.2032-.5377-1.2032-1.2004V9c0-.66263.5384-1.20038 1.2032-1.20038.6649 0 1.2044.53775 1.2044 1.20038v10.7932z"
        fill="#000"
      />
      <style jsx>
        {`
          svg {
            display: block;
          }
        `}
      </style>
    </svg>
  )
}
